<template>
  <swiper :class="$style.swiper" :style="{ height: this.customHeight }" :options="swiperOption">
    <swiper-slide
      v-for="item of swiperList"
      :key="item.id"
      :class="$style.swiper_item"
      @click.native="handleLinkTo('giftCenter.details', { giftId: item.id })"
    >
      <img :src="item.icon" />
      <div>
        <p>{{ item.title }}</p>
        <p>{{ item.description }}</p>
      </div>
      <button v-if="item.can_get == 1" @click.stop="handleReceiveGift(item)">领取</button>
      <button v-else style="background-color: #9d9d9d" @click.stop="alreadyReceivedGift(item)">
        已领取
      </button>
    </swiper-slide>
  </swiper>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { reportData } from '@/api/report';
import 'swiper/css/swiper.css'
let vm = ''

export default {
  name: 'verLayout',
  props: {
    swiperList: {
      type: Array,
      default: () => []
    },
    plateId: {
      type: [String, Number],
      default: 0
    },
    slidesPerViewNum: {
      type: [String, Number],
      default: 0
    },
    customHeight: {
      type: String,
      default: 'auto'
    },
    allowTouchMove: {
      type: Boolean,
      default: false
    },
    isAllGift: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    swiperOption() {
      return {
        direction: 'vertical',
        slidesPerView: this.slidesPerViewNum ? this.slidesPerViewNum : this.swiperList.length,
        spaceBetween: 10,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        allowTouchMove: this.allowTouchMove
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  created() {
    vm = this
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM'
    }),
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    // 打开领取礼包弹窗
    handleReceiveGift(item) {
      if (this.plateId) {
        reportData({
          type: 10,
          data_type: 7,
          gift_plate_id: this.plateId
        })
      }
      this.SHOW_GIFT_DIALOG(true)
      this.SET_GIFT_ITEM(item)
    },
    // 点击已领取按钮
    alreadyReceivedGift(item) {
      if (this.plateId) {
        reportData({
          type: 10,
          data_type: 7,
          gift_plate_id: this.plateId
        })
      }
      reportData({
        type: 10,
        data_type: 9,
        extend: '6',
        gift_set_id: item.id
      })
      // this.SHOW_GIFT_DIALOG(true)
      this.SET_GIFT_ITEM(item)
      this.$bus.$emit('showNormalDialog', 'receivedGift')
    },
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/_variable.scss';
.swiper {
  margin: 8px 0px 8px 8px;
}
.swiper_item {
  display: flex;
  align-items: center;
  height: 45px !important;
  img {
    width: 45px;
  }
  div {
    margin: 0px 8px;
    width: 218px;
    p:first-child {
      margin-bottom: 8px;
      font-size: 11px;
    }
    p:last-child {
      @include ellipsis(1);
      font-size: 10px;
      color: #9f9f9f;
    }
  }
  button {
    @include clearBtnDefaultStyle;
    padding: 0;
    width: $buttonWidth;
    height: $buttonHeight;
    line-height: $buttonHeight;
    color: #fff;
    font-size: 10px;
    background-color: $buttonColor;
    border-radius: 15px;
  }
}
</style>

